import {createAsyncThunk} from "@reduxjs/toolkit";
import request from "../../../../service";
import {IErrorResponse} from "../../../../types";
import {
    deletedRestoreWorkload,
    deletedWorkload, setItemWorkload,
    setRestoreWorkload,
    setWorkloadData,
    updateWorkload
} from "../store/workloadSlice";
import {IWorkloadCreate, IWorkloadPayload} from "../types";





const GetWorkload = createAsyncThunk(
    "get/workload",
    async (_, { dispatch,rejectWithValue }) => {
        try {
            const response = await request.get("/employee-workloads");
            dispatch(setWorkloadData(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);



const SetWorkload =createAsyncThunk(
    "create/workload",
    async (data:IWorkloadCreate, { rejectWithValue }) => {
        try {
            return await request.post("/employee-workloads",data);
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const EditWorkload= createAsyncThunk(
    "edit/workload",
    async ( data :IWorkloadPayload, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.put(`/employee-workloads/${data.id}`, data);
            dispatch(updateWorkload(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


const DeleteWorkload= createAsyncThunk(
    "delete/workload",
    async (id:number, { dispatch,rejectWithValue }) => {
        try {
            const response = await request.delete(`/employee-workloads/${id}`);
            dispatch(deletedWorkload(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


const GetDeletedWorkload= createAsyncThunk(
    "get/delete/workload",
    async (_, { dispatch,rejectWithValue }) => {
        try {
            const response = await request.get(`/employee-workloads/deleted-items`);
             dispatch(setRestoreWorkload(response.data))
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);
const RestoreDeleteWorkload = createAsyncThunk(
    "restore/delete/Workload",
    async (id:number,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.post(`/employee-workloads/restore/${id}`);
            dispatch(deletedRestoreWorkload(id));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


const GetItemWorkload =createAsyncThunk(
    "get/item/Workload",
    async (id:number,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.get(`/employee-workloads/${id}`);
            dispatch(setItemWorkload(response.data))
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


export{
    GetWorkload,
    SetWorkload,
    EditWorkload,
    DeleteWorkload,
    GetDeletedWorkload,
    RestoreDeleteWorkload,
    GetItemWorkload
}